import React from "react";

import { Props } from "./types";

function StatusIcon({ className, style }: Props) {
  return (
    <svg className={className} style={style} viewBox="0 0 12 12">
      <rect width="10" height="10" x="1" y="1" fillRule="evenodd" rx="1" />
    </svg>
  );
}

export { StatusIcon };
